import { Loading } from 'element-ui';

let loadingCount = 0;
let loading;
let loadingTimer;

const startLoading = () => {
  loading = Loading.service({
    lock: true,
    customClass: 'site-request-loading',
    background: 'rgba(255, 255, 255, 0.16)',
    // text: '拼命加载中...',//可以自定义文字
    // spinner:'el-icon-loading',//自定义加载图标类名
    // background: 'rgba(0, 0, 0, 0.7)'//遮罩层背景色
  });
};

const endLoading = () => {
  clearTimeout(loadingTimer);
  if (loading) {
    loading.close();
    loading = null;
  }
};

export const showLoading = () => {
  if (loadingCount === 0) {
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(startLoading, 180);
  }
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};



// WEBPACK FOOTER //
// ./src/request/loading.js